import React, { useEffect, useState } from "react";
import { creditVoucherService } from "_services/creditvoucher.service";
import {
  Breadcrumb,
  PageHeader,
  Form,
  Col,
  Row,
  Spin,
  Input,
  message,
  InputNumber,
} from "antd";
import { Link } from "react-router-dom";
import Page from "_components/Page";
function Summary({ match }) {
  const [loading, setLoading] = useState(null);
  const [voucher, setVoucher] = useState(null);

  const { id } = match.params;
  const { path } = match;
  const [form] = Form.useForm();

  useEffect(() => {
    getVoucherSummary(id);
  }, [id]);

  const getVoucherSummary = (id) => {
    creditVoucherService
      .getById(id)
      .then((data) => {
        setVoucher(data.content);
        onFill(data.content);
        setLoading(false);
      })
      .catch((error) => {
        message.error(error);
        setLoading(false);
      });
  };

  const onFill = (data) => {
    form.setFieldsValue(data);
  };

  return (
    <PageHeader
      title={
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/dashboard">Dashboard</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            {" "}
            <Link to="/credit-vouchers">Credit Vouchers</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            {" "}
            <Link to={`${path}`.replace(":id", id)}>Summary</Link>
          </Breadcrumb.Item>
        </Breadcrumb>
      }
    >
      <Spin spinning={loading}>
        <Page inner>
          <Form
            name="form-edit"
            form={form}
            className="search-form"
            layout="vertical"
          >
            <Row gutter={24}>
              <Col span={6}>
                <Form.Item name={["creditType"]} label="Credit Type">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name={["currency", "name"]} label="Currency Type">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name={["creditAmount"]} label="Credit Amount">
                  <InputNumber addonAfter="LKR" defaultValue={100} readOnly />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name={["receivedDate"]} label="Received Date">
                  <Input readOnly />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={6}>
                <Form.Item
                  name={["stockIssue", "issueNumber"]}
                  label="Stock Issue Number"
                >
                  <Input readOnly />
                </Form.Item>
              </Col>

              <Col span={6}>
                <Form.Item name={["remarks"]} label="Remarks">
                  <Input readOnly />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={6}>
                <Form.Item name={["currency", "id"]}>
                  <Input hidden />
                </Form.Item>
              </Col>

              <Col span={6}>
                <Form.Item name={["id"]}>
                  <Input hidden />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Page>
      </Spin>
    </PageHeader>
  );
}

export default Summary;
